import { queryOptions, useQuery } from "@tanstack/react-query";

import type { WorkspacePage } from "~/workspaces/state/workspace-page";
import type { GetWorkspacePagesParams } from "~/workspaces/api/get-workspace-pages";
import { getWorkspacePages } from "~/workspaces/api/get-workspace-pages";

function getWorkspacePagesQueryOptions(params: GetWorkspacePagesParams) {
  return queryOptions({
    queryKey: ["workspace", "pages", params],
    queryFn: () => getWorkspacePages(params),
    enabled: typeof params.workspaceId !== "undefined",
  });
}

function useGetWorkspacePages<TData = WorkspacePage[]>(
  params: GetWorkspacePagesParams,
  select?: (data: WorkspacePage[]) => TData,
) {
  return useQuery({
    ...getWorkspacePagesQueryOptions(params),
    select,
  });
}

export { useGetWorkspacePages, getWorkspacePagesQueryOptions };
